import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {IApplySearch,IApplyParams,IApplyDetail,IApplyInsert,IApplyUpdata,IApplyDisable} from "./applyTypes"
class ApplyService {
    async page(params:IApplySearch){
        const apiUrl = "/md/app/page"
        return await httpRequest.post<IPage<IApplyDetail>>(apiUrl,params)
    }
    async insert(params:IApplyInsert){
        const apiUrl = "/md/app/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IApplyUpdata){
        const apiUrl = "/md/app/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IApplyDisable){
        const apiUrl = "/md/app/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const applyService = new ApplyService()
export {
    applyService
}